/**
 * Template type enum matching backend TemplateType.
 */
export var TemplateType;
(function (TemplateType) {
    TemplateType["System"] = "System";
    TemplateType["Organization"] = "Organization";
    TemplateType["User"] = "User";
    TemplateType["Reference"] = "Reference";
    TemplateType["Campaign"] = "Campaign";
})(TemplateType || (TemplateType = {}));
/**
 * Template support type matching backend TemplateSupport.
 */
export var TemplateSupport;
(function (TemplateSupport) {
    TemplateSupport["Email"] = "Email";
    TemplateSupport["Form"] = "Form";
    TemplateSupport["LandingPage"] = "LandingPage";
    TemplateSupport["Sms"] = "Sms";
    TemplateSupport["WhatsApp"] = "WhatsApp";
    TemplateSupport["Notification"] = "Notification";
})(TemplateSupport || (TemplateSupport = {}));
/**
 * Template status enum matching backend TemplateStatus.
 */
export var TemplateStatus;
(function (TemplateStatus) {
    TemplateStatus["Draft"] = "Draft";
    TemplateStatus["Published"] = "Published";
    TemplateStatus["Archived"] = "Archived";
})(TemplateStatus || (TemplateStatus = {}));
/** Whether a template can be published (Draft, or Published with unpublished newer versions). */
export function canPublishTemplate(template) {
    if (template.status === TemplateStatus.Draft)
        return true;
    if (template.status !== TemplateStatus.Published)
        return false;
    // When the flag is not available (list views), fall back to allowing publish.
    return template.hasUnpublishedDraft ?? true;
}
